import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/settings/integrations")({
  head: () => ({ meta: [{ title: "Integrations | Settings" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-settings-integrations")),
});
